var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "orange"
  }, [_vm._v("未来基因（北京）人工智能研究院")]), _c('p', [_vm._v("基于")]), _c('p', {
    staticClass: "orange"
  }, [_vm._v("2022年教育部颁布的《义务教育阶段信息科技课程标准》\n  ")]), _c('p', [_vm._v("研发的")]), _c('p', {
    staticClass: "orange"
  }, [_vm._v("FutureAI ")]), _c('p', {
    staticClass: "orange"
  }, [_vm._v("信息科技核心素养评价系统")]), _c('p', {
    staticClass: "orange"
  }, [_vm._v("上线啦！")]), _c('img', {
    staticStyle: {
      "width": "677px"
    },
    attrs: {
      "src": require("../assets/join/1.png"),
      "alt": ""
    }
  }), _c('img', {
    attrs: {
      "src": require("../assets/join/2.png"),
      "alt": ""
    }
  }), _c('p', [_vm._v("欢迎广大信息科技教师")]), _c('p', [_vm._v("申请免费试用")]), _c('p', {
    staticClass: "orange"
  }, [_vm._v("-----【免费试用】-----")]), _c('img', {
    staticStyle: {
      "width": "151px"
    },
    attrs: {
      "src": require("../assets/join/3.png"),
      "alt": ""
    }
  }), _c('p', [_vm._v("我们将为您"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("提供教学评价服务")])]), _c('p', [_vm._v("即刻"), _c('span', {
    staticClass: "orange"
  }, [_vm._v("开始体验")])]), _c('p', {
    staticClass: "orange"
  }, [_vm._v("FutureAI ")]), _c('p', {
    staticClass: "orange"
  }, [_vm._v("信息科技核心素养评价系统")]), _c('img', {
    attrs: {
      "src": require("../assets/join/4.png"),
      "alt": ""
    }
  })]);
}];
export { render, staticRenderFns };